<template>
  <div class="flex flex-column align-items-center justify-content-center pt-3 pb-3">
    <PrimevueCard  class="sm:w-12 md:w-10 lg:w-8 xl:w-8 mb-2">
      <template #title>KUS</template>
      <template #subtitle >
        <div class="mb-3 border-solid border-1 surface-border">
        </div>
        <div class="field flex justify-content-center">
          <router-link to="/mod-stock/scan-item" class="w-full">
            <PrimevueButton label="Skenovať QR kód" severity="success" icon="pi pi-camera" text raised class="uppercase w-full"/>
          </router-link>
        </div>
        <div class="field flex justify-content-center">
          <PrimevueButton @click="printLabel()" label="Vytlač štítok" 
            :disabled="!(this.stockItem.id > 0)" icon="pi pi-print"
            severity="success" text raised class="w-full uppercase"/>
        </div>
      </template>
      <template #content>
          
          <form @submit.prevent="submitHandler" name="itemForm">
            <div class="grid">
              <div class="col-12 md:col-6 lg:col-6 p-2">
                
                <div class="field">
                  <label for="item-category">Kategória</label>

                  <PrimevueSelect
                      id="item-category"
                      v-model="this.selectedCategory"
                      :options="this.categories"
                      optionLabel="name"
                      placeholder="Vyber kategóriu"
                      class="w-full"
                      :class="`${v$.selectedCategory.$error ? 'bg-red-200' : ''}`"
                      :invalid="v$.selectedCategory.$error"
                      @change="filterProducts(this.selectedCategory.id)"
                  >
                    <template #value="slotProps">
                      <div v-if="slotProps.value.id != 0" class="">
                          <div>{{ slotProps.value.name }}</div>
                      </div>
                      <span v-else>
                        {{ slotProps.placeholder }}
                      </span>
                    </template>
                    <template #option="slotProps">
                        <div class="">
                           <div>{{ slotProps.option.name }}</div>
                        </div>
                    </template>
                  </PrimevueSelect>  
                  <div
                      v-for="(error, index) of v$.selectedCategory.$errors"
                      :key="index"
                      class="text-sm font-italic text-red-400"
                  >
                    {{ error.$message }}
                  </div>
                </div>                            

                <div class="field">
                  <label for="item-product">Produkt</label>
                  <div class="flex align-items-center justify-content-between gap-1" >
                      <PrimevueSelect
                          id="item-product"
                          :disabled="!this.selectedCategory.name"
                          v-model="this.selectedProduct"
                          :options="this.products"
                          filter
                          optionLabel="code"
                          placeholder="Vyber produkt"
                          class="w-full"
                          :class="`${v$.selectedProduct.$error ? 'bg-red-200' : ''}`"
                          :invalid="v$.selectedProduct.$error"
                          @change="selectProduct()"
                      >
                        <template #value="slotProps">
                          <div v-if="slotProps.value.id != 0" class="">
                              <div>{{ slotProps.value.code }} * 
                                {{ slotProps.value.name.length > 31 ? slotProps.value.name.slice(0, 31) + '...' : slotProps.value.name }} 
                              </div>
                          </div>
                          <span v-else>
                            {{ slotProps.placeholder }}
                          </span>
                        </template>
                        <template #option="slotProps">
                            <div class="">
                              <div>{{ slotProps.option.code }} * 
                                   {{ slotProps.option.name }}
                              </div>
                            </div>
                        </template>
                      </PrimevueSelect>  
                      <PrimevueButton type="button" v-tooltip.top="{ value: 'Zobrazenie a výber produktov' }" class="products"
                        icon="pi pi-table" @click="this.visibleProducts = true" text severity="primary" size="large"
                      />
                    </div>
                    <div
                        v-for="(error, index) of v$.selectedProduct.$errors"
                        :key="index"
                        class="text-sm font-italic text-red-400"
                    >
                      {{ error.$message }}
                    </div>
                </div>                            

                <div class="field">
                  <label for="item-code">Kód</label>
                  <InputText class="w-full" 
                    disabled
                    v-model="this.stockItem.code"
                    type="text"
                    name="item-code"
                    id="item-code"
                  >
                  </InputText>

                </div>


                <div class="flex justify-content-center">
                  <!-- Náhľad obrázka -->
                  <div
                    class="image-container"
                    v-if="this.stockItem.product.image"
                    
                  >
                    <!-- Obrázok -->
                    <img :src="this.stockItem.product.image" alt="Preview Image" class="preview-image"/>
                
                  </div>
              
                  <!-- Štvorcové tlačidlo na výber obrázka, ak nie je žiadny obrázok -->
                  <div
                    class="image-container placeholder"
                    v-else
                  >
                  <i class="pi pi-image placeholder-icon"></i>
                  </div>
                </div>
              </div>
              
              <div class="col-12 md:col-6 lg:col-6 p-2">
                
                <div class="field">
                  <label for="item-name">Názov</label>
                  <InputText class="w-full" 
                    disabled
                    v-model="this.stockItem.product.name"
                    type="text"
                    name="item-name"
                    id="item-name"
                  >
                  </InputText>
                </div>
              
                <div class="field">
                  <label for="item-length">Dĺžka</label>
                  <InputNumber class="w-full" inputId="item-length" :useGrouping="false"
                    :disabled="!(this.selectedCategory.name && this.selectedProduct.code)"
                    v-model="this.stockItem.length"
                    name="item-length"
                    id="item-length"
                    :inputClass="`${v$.stockItem.length.$error ? 'bg-red-200' : ''}`"
                    :invalid="v$.stockItem.length.$error"
                  >
                  </InputNumber>
                  <div
                    v-for="(error, index) of v$.stockItem.length.$errors"
                    :key="index"
                    class="text-sm font-italic text-red-400"
                  >
                    {{ error.$message }}
                  </div>
                </div>            
                
                <div class="field">
                  <div class="flex align-items-center justify-content-between" style="margin-bottom: 0.45rem;">
                    <span class="">Farba</span>
                    <div class="flex align-items-center justify-content-right"> 
                      <label for="imitation" class="mr-2">Imitácia dreva</label>
                      <PrimevueCheckbox 
                        v-model="this.imitation" inputId="imitation" name="imitation" :binary="true"
                        @change="setColors()"
                      />
                      
                    </div>
                  </div>
                  <PrimevueSelect
                      id="item-color"
                      :disabled="!(this.selectedCategory.name && this.selectedProduct.code)"
                      v-model="this.selectedColor"
                      :options="this.colors"
                      optionLabel="code"
                      placeholder="Vyber farbu"
                      class="w-full"
                      :class="`${v$.selectedColor.$error ? 'bg-red-200' : ''}`"
                      :invalid="v$.selectedColor.$error"
                  >
                  <template #value="slotProps">
                    <div v-if="slotProps.value.id != 0" class="flex align-items-center">
                        <div
                          class="color-box mr-2"
                          :style="{ backgroundColor: slotProps.value.colorHash }"
                        ></div>  
                        <div>{{ slotProps.value.code }}</div>
                    </div>
                    <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                  </template>
                  <template #option="slotProps">
                      <div class="flex align-items-center">
                          <div
                            class="color-box mr-2"
                            :style="{ backgroundColor: slotProps.option.colorHash }"
                          ></div>  
                          <div>{{ slotProps.option.code }}</div>
                      </div>
                  </template>
                  </PrimevueSelect>
                  <div
                    v-for="(error, index) of v$.selectedColor.$errors"
                    :key="index"
                    class="text-sm font-italic text-red-400"
                  >
                    {{ error.$message }}
                  </div>
                </div>            

                <div class="field">
                  <label for="item-type">Poznámka</label>
                  <InputText class="w-full" 
                    :disabled="!(this.selectedCategory.name && this.selectedProduct.code)"
                    v-model="this.stockItem.comment"
                    type="text"
                    name="item-type"
                    id="item-type"
                  >
                  </InputText>

                </div>

                <div class="field">
                  <label for="item-location">Umiestnenie</label>
                  <InputText class="w-full" 
                    :disabled="!(this.selectedCategory.name && this.selectedProduct.code)"
                    v-model="this.stockItem.location"
                    type="text"
                    name="item-location"
                    id="item-location"
                  >
                  </InputText>

                </div>

                <div class="w-12 grid ml-0 mr-0">
                  <div class="col-4 pl-0 pr-1 pb-0">
                    <div class="field mb-3">
                      <div class="flex align-items-center justify-content-left"> 
                        <PrimevueCheckbox :disabled="!(this.selectedCategory.name && this.selectedProduct.code)"
                          v-model="this.stockItem.wholePiece" inputId="wholePiece" name="wholePiece" :binary="true"/>
                        <label for="wholePiece" class="ml-2">Celý kus</label>
                      </div>
                    </div>
                    <div class="field" style="margin-bottom: 1.14rem;">
                      <div class="flex align-items-center justify-content-left"> 
                        <PrimevueCheckbox :disabled="!(this.selectedCategory.name && this.selectedProduct.code)"
                          v-model="this.stockItem.reserved" inputId="reserved" name="reserved" :binary="true"
                          @change="setReserved()"
                        />
                        <label for="reserved" class="ml-2">Rezervovaný</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-8 pl-2 pb-0 pr-0">
                    <div class="field mb-3">
                      <div class="flex align-items-center justify-content-left"> 
                        <PrimevueCheckbox :disabled="!(this.selectedCategory.name && this.selectedProduct.code)"
                          v-model="this.stockItem.readyToSpray" inputId="readyToSpray" name="readyToSpray" :binary="true"/>
                        <label for="readyToSpray" class="ml-2">Pripravený na nastriekanie</label>
                      </div>
                    </div>
                    <div class="field" style="margin-bottom: 1.14rem;">
                      <div class="flex align-items-center justify-content-left"> 
                        <PrimevueCheckbox :disabled="!(this.selectedCategory.name && this.selectedProduct.code && this.stockItem.readyToSpray)"
                          v-model="this.stockItem.sprayed" inputId="sprayed" name="sprayed" :binary="true"
                           
                        />
                        <label for="sprayed" class="ml-2">Nastriekaný</label>
                      </div>
                    </div>
                  </div>

                </div> 
                <div class="field" style="position: relative;">
                  <label for="item-order">Objednávka</label>
                  <PrimevueButton @click="this.visibleSelect = !this.visibleSelect" 
                      :disabled="!(this.selectedCategory.name && this.selectedProduct.code && this.stockItem.reserved)"
                      label="test" 
                      style="height: 2rem;"
                      class="flex justify-content-between w-full " outlined
                      :class="`${v$.stockItem.order.$error ? 'bg-red-200' : ''}`"
                      :invalid="v$.stockItem.order.$error"
                      id="item-order">
                    <span >
                    <span v-if="this.stockItem.order.id > 0">
                      <span >{{this.stockItem.order.orderCode}}</span> *
                      <span >{{this.stockItem.order.customer.lastName}}</span> *
                      <span >{{this.stockItem.order.customer.city}}</span>
                    </span>
                    </span>
                    <span class="flex justify-content-center align-items-center" style="width: 1.8rem;">
                      <svg width="14" height="14" viewBox="0 0 14 14" 
                            fill="none" xmlns="http://www.w3.org/2000/svg" class="p-icon p-button-icon">
                            <path d="M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z" fill="currentColor"></path>
                      </svg>
                    </span>
    
                  </PrimevueButton>
                  <div
                    v-for="(error, index) of v$.stockItem.order.$errors"
                    :key="index"
                    class="text-sm font-italic text-red-400"
                  >
                    {{ error.$message }}
                  </div>
                  <div v-if="this.visibleSelect" class="card" 
                      style="z-index: 10; position: absolute; top: 56px; left: 2px; min-width: 20rem; transform-origin: center top; margin-top: 2px;">
            
                      <!-- <div class="ml-1 mt-1 flex justify-content-start"> -->
                        <IconField iconPosition="left">
                         
                          <InputIcon>
                            <i class="pi pi-search "/>
                          </InputIcon>
                          <InputText v-model="orderFilters['global'].value" placeholder="Vyhľadať" @input="onOrderFilter" 
                         
                          />
                        </IconField>
                      <!-- </div> -->
                    <DataTable
                        
                        lazy paginator :rows="this.selectParams.rows"
                        @page="onOrderPage"
                        :first="this.selectParams.first"
                        :loading="selectLoading"
                        :totalRecords="this.selectParams.totalRecords"
                        dataKey="id"
                        :value="this.orderOptions"
                        :scrollHeight="`${200}px`"
                        :virtualScrollerOptions="{ itemSize: 40 }"
                        stripedRows
                        row-hover
                        scrollable
                        v-model:selection="this.selectedOrder"
                        selectionMode="single"
                        :metaKeySelection="false"
                        @rowSelect="selectOrder(this.selectedOrder)"
                        size="small"
                    >
                        <Column header="ID" field="orderCode" style="width: 5%">
                        </Column>
                        <Column header="Meno" field="customer.lastName" style="width: 50%">
                        </Column>    
                        <Column header="Obec" field="customer.city" style="width: 45%">
                        </Column>              
                    </DataTable>              
                  </div>
    
                </div>  

                <div class="field">
                  <div class="flex align-items-center justify-content-between" style="margin-bottom: 0.45rem;">
                    <div class="w-6 pr-2">
                      <InputNumber inputId="cut-length" :useGrouping="false"
                        :disabled="!(this.stockItem.id > 0)"
                        v-model="this.cutLength"
                        name="cut-length"
                        id="cut-length"
                        :inputClass="`${this.cutLengthIsWrong  ? 'bg-red-200 w-full h-2rem' : 'w-full h-2rem'}`"
                        :invalid="this.cutLengthIsWrong"
                        placeholder="Dĺžka odrez. kusa"
                      >
                      </InputNumber>
                      <div
                        v-if="this.cutLengthIsWrong"
                        class="text-sm font-italic text-red-400"
                      >
                        Chybná dĺžka odrezaného kusa
                      </div>
                    </div>

                    <div class="w-6 flex justify-content-center">
                      <PrimevueButton @click="cutItem()" label="Odrež z kusa" 
                        :disabled="!(this.stockItem.id > 0)"
                        style="padding-top: 0.42rem; padding-bottom: 0.324rem;"
                        severity="success" text raised class="w-full uppercase"/>
                    </div>

                  </div>
                </div>  

              </div>

            </div>           

            <div class="field flex justify-content-center">
              <PrimevueButton @click="eliminateItem()" label="Vyraď kus" 
                :disabled="!(this.stockItem.id > 0)"
                severity="danger" text raised class="w-full uppercase"/>
            </div>
            
            <div class="mt-3 mb-3 border-solid border-1 surface-border"></div>
            
            <div class="mt-2 flex flex-wrap justify-content-center gap-3">
                <PrimevueButton type="submit" label="Uložiť" text raised class="uppercase"/>
                <router-link to="/mod-stock/stock-items">
                      <PrimevueButton label="Zrušiť" severity="danger" text raised class="uppercase"/>
                </router-link>
            </div>
          </form>
        </template>
    </PrimevueCard>
    
    <PrimevueCard  class="sm:w-12 md:w-10 lg:w-8 xl:w-8">
      <template #title>Pohyby s kusom</template>
      <template #subtitle ><div class="mb-3 border-solid border-1 surface-border"></div></template>
      <template #content>
        
            <ul>
              <li v-for="history in this.store.stockMovements" v-bind:key="history.id">
                <i class="pi pi-clock"></i>
                {{ Utils.formatToSlovak(history.createdAt) }}
                <PrimevueTag class="text-base" :value="history.action" :style="{ backgroundColor: history.color }"/>
                - {{ history.user.firstName }} {{ history.user.lastName }}
              </li>
            </ul>
       
      </template>
    </PrimevueCard>

      <PrimevueDialog v-model:visible="this.visibleProducts" header="Produkty" :style="{ width: '60rem' }"> 
        <div class="grid">
          <div v-for="(prod,index) in this.products" v-bind:key="index" class="p-1 sm:col-12 md:col-4 lg:col-4 xl:col-4">
              <PrimevueButton outlined 
                class="p-1"  @click="setSelectProduct(prod) "
                @mouseover="this.hoverIndex = index"
                @mouseleave="this.hoverIndex = null"
                :style="buttonStyle(index)"   
                >
                <div class="grid w-full h-full">
                  <div class="col-6 p-2">
                    <div class="text-left font-bold">{{ prod.code }}</div>
                    <div class="text-left mt-5">{{ prod.name }}</div>
                  </div>
                  <div class="col-6 p-1 flex justify-content-center">
                    <div class="w-full h-full flex justify-content-center align-items-center">
                      <img :src="prod.image" 
                          :style="`${prod.imageHeight >= prod.imageWidth ? 'height:168px;' : 'width:140px;'}`"
                          @load="checkImageSize(index,$event)"
                          alt="Preview Image" class=""/>
                    </div>
                  </div>
                </div> 
              </PrimevueButton>
          </div>
        </div>  
      </PrimevueDialog>



    <ConfirmDialog></ConfirmDialog>
  </div>
  
</template>


<script lang="ts">
import Security from "@/components/security";
import {store} from "@/components/store";
import notie from "notie/dist/notie";
import router from "@/router";
import PrimevueButton from 'primevue/button';
import PrimevueSelect from "primevue/dropdown";
import PrimevueCard from 'primevue/card';
import PrimevueCheckbox from 'primevue/checkbox';
import PrimevueTag from "primevue/tag";
import PrimevueDialog from 'primevue/dialog';
import { required, helpers  } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import {FilterMatchMode} from "primevue/api";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import IconField from 'primevue/iconfield';
import InputIcon from "primevue/inputicon";
import Utils from './utils';

const notBeZero = (value : number) => value > 0

const requiredWhenReserved = (param) =>
  helpers.withParams(
    { type: 'requiredWhenReserved', value: param },
    (value:number) => !param || value > 0
  ) 
interface DataMovement {
  stockItem: { id: number };
  action: string;
  user: any; 
  color: string;
  order?: any; 
}

export default {
  name: "StockItemEdit",
  components: {
      PrimevueTag,
      PrimevueCheckbox,
      PrimevueButton,
      PrimevueSelect,
      PrimevueCard,
      DataTable,
      Column,
      IconField,
      InputIcon,
      PrimevueDialog,
  },
  data() {
    return {
      store,
      hoverIndex: null,
      visibleProducts: false,
      imitation: false,
      cutLengthIsWrong: false,
      cutLength: null,
      action: "",
      typeOfAction: "",
      oldLocation: "",
      oldReadyToSpray: false,
      oldSprayed: false,
      oldOrderCode: 0,
      isMovement: false,
      routeParams: null,
      categories: [],
      selectedCategory: {id:0,name:""},
      colors: [],
      selectedColor: {id:0,code:""},
      products: [],
      selectedProduct: {id:0,code:"",name:""},
      stockItem: {
        id: 0,
        code: "",
        product:{id:0,code:"",name: "",image: ""},
        length: 0,
        location: "",
        category: {},
        color: {id:0,code:""},
        order:{id:0,orderCode:0,customerLastName:"",customer:{lastName:"",city:""}},
        comment: "",
        wholePiece: true,
        reserved: false,
        eliminated: false,
        eliminatedAt: null,
        reservedAt: null,
        readyToSpray: false,
        sprayed: false,
      },
      orderOptions: [],
      selectedOrder: null,
      visibleSelect: false,
      selectLoading: false,
      orderFilters : {
          global: {value: null, matchMode: FilterMatchMode.CONTAINS},
      },
      selectParams: {
        first: 0,
        rows: 100,
        totalRecords: 0,
        filters:{global: "",
                 table:"order",
                 globalFilterFields: ['OrderCode', 'CustomerId__LastName','CustomerId__City']
                },

      },
    }
  },
  setup () {
    return {
      v$: useVuelidate()
    }
  },

  computed: {
    Utils() {
      return Utils
    },
  },

  validations () {
    return {
      stockItem: {
        length: { notBeZero: helpers.withMessage('Dĺžka nesmie byť nulová', notBeZero),
                //minLength: helpers.withMessage('Dĺžka musí obsahovať min. 1 znak', minLength(1)),
              },
        order:{orderCode: { requiredWhenReserved: helpers.withMessage('Ak je kus rezervovaný, objednávka nesmie byť prázdna',  
                            requiredWhenReserved(this.stockItem.reserved))},
              },       
      },

      selectedCategory: {
           name: { required: helpers.withMessage('Kategória nesmie byť prázdna', required)},
                
              }, 
      selectedProduct: {
           code: { required: helpers.withMessage('Product nesmie byť prázdny', required)},
                
              },                         
      selectedColor: {
           code: { required: helpers.withMessage('Farba nesmie byť prázdna', required)},
                
              },      
      
    }
  },
  methods: {

    buttonStyle(index) {
      return {
        height: '172px',
        width: '295px',
        borderWidth: this.hoverIndex === index ? '2px' : '1px',
        borderColor: this.hoverIndex === index ? '#0000FF' : '#ccc', // Farba okraja
        transition: 'border-width 0.2s ease-in-out,border-color 0.2s ease-in-out'
      };
    },

    async submitHandler() {
      const result = await this.v$.$validate()
      
      if (!result) {
        // notify user form is invalid
        return
      }

      const stockItemId = parseInt(String(this.routeParams.stockItemId), 10)

      const formData = {
        id: this.stockItem.id,
        code: this.stockItem.code,
        location: this.stockItem.location,
        length: this.stockItem.length,
        comment: this.stockItem.comment,
        wholePiece: this.stockItem.wholePiece,
        reserved: this.stockItem.reserved,
        reservedAt: this.stockItem.reservedAt,
        product: this.stockItem.product,
        color: this.selectedColor,
        order: this.stockItem.order,
        eliminated: this.stockItem.eliminated,
        eliminatedAt: this.stockItem.eliminatedAt,
        readyToSpray: this.stockItem.readyToSpray,
        sprayed: this.stockItem.sprayed,

      }


      let method = "POST"
      let url = "/v1/stock-item/"
      
      if (stockItemId > 0){
        method = "PUT"
        url = "/v1/stock-item/" + stockItemId
       

      }else{
        
        this.typeOfAction = "ADD"
        
      }

      fetch(store.Api_url + url, Security.requestOptions(method, formData))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              
              notie.alert({
                type: 'error',
                text: responseData.data.message
              })
            } else {
              notie.alert({
                type: 'success',
                text: "Kus bol uložený"
              })
              this.stockItem = responseData.data
              this.addStockMovement()

              this.oldLocation = this.stockItem.location
              this.oldOrderCode = this.stockItem.order.orderCode
              this.oldReadyToSpray = this.stockItem.readyToSpray
              this.oldSprayed = this.stockItem.sprayed
              
              if (this.typeOfAction == "DEL"){
                this.typeOfAction = ""
                router.push("/mod-stock/stock-items");
              }else{
                this.typeOfAction = ""
                router.push("/mod-stock/stock-items/"+String(this.stockItem.id));
              }
              
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri uložení kusa" + error);
            notie.alert({
              type: 'error',
              text: "Chyba pri uložení kusa" + error
            })
          })


    },
    
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    checkImageSize(index,event) {
      this.products[index].imageWidth = event.target.naturalWidth;
      this.products[index].imageHeight = event.target.naturalHeight;
    },

    setSelectProduct(product){
      this.selectedProduct = product
      this.visibleProducts = false
      this.selectProduct()
    },

    addStockMovement(){
      let dataMovement: DataMovement = {stockItem:{id:this.stockItem.id},
                              action:"",
                              user:store.user,
                              color:"",
                        }
                        
      if  (this.typeOfAction == "ADD"){
        dataMovement.action = Utils.getAddTextAction("Kus")
        
        Utils.addStockMovement(dataMovement,"stock_item_id",this.typeOfAction,this.stockItem.id)
      }

      this.sleep(500);

      if  (this.typeOfAction == "DEL"){
        dataMovement.action = Utils.getDelTextAction("Kus")
        Utils.addStockMovement(dataMovement,"stock_item_id",this.typeOfAction,this.stockItem.id)
      }      

      if (this.oldLocation != this.stockItem.location){
         dataMovement.action = Utils.getChangeLocationTextAction("Kus",this.stockItem.location)
         //this.typeOfAction = "CHA"
         Utils.addStockMovement(dataMovement,"stock_item_id","CHA",this.stockItem.id)

      }

      if (this.oldOrderCode != this.stockItem.order.orderCode && this.stockItem.reserved){
         dataMovement.action = Utils.getReservedOrderTextAction("Kus",String(this.stockItem.order.orderCode))
         dataMovement.order = {id:this.stockItem.order.id}
         Utils.addStockMovement(dataMovement,"stock_item_id","CHA",this.stockItem.id)
      }
      
      if (this.oldOrderCode != this.stockItem.order.orderCode && !this.stockItem.reserved){
         dataMovement.action = Utils.getCanceledReservationOrderTextAction("kusa",String(this.oldOrderCode))
         dataMovement.order = null //{id:this.stockItem.order.id}
         Utils.addStockMovement(dataMovement,"stock_item_id","CHA",this.stockItem.id)
      }
      
      if (this.oldReadyToSpray != this.stockItem.readyToSpray && !this.oldReadyToSpray){
         dataMovement.action = "Kus je pripravený na nastriekanie"
         Utils.addStockMovement(dataMovement,"stock_item_id","CHA",this.stockItem.id)
      }

      if (this.oldSprayed != this.stockItem.sprayed && !this.oldSprayed){
         dataMovement.action = "Kus bol nastriekaný"
         Utils.addStockMovement(dataMovement,"stock_item_id","CHA",this.stockItem.id)
      }
    },

    setReserved(){
      if (this.stockItem.reserved){
        this.stockItem.reservedAt = new Date()
      }else{
        this.stockItem.reservedAt = null
        this.stockItem.order = {id:0,orderCode:0,customer:{lastName:"",city:""}}
      }
    },

    eliminateItem() {
      this.$confirm.require({
          message: 'Naozaj chcete kus vyradiť?',
          header: 'Vyradenie kusa',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: "Áno",
          rejectLabel: "Nie",

          accept: () => {
            this.stockItem.eliminated = true
            this.stockItem.eliminatedAt = new Date()
            
            this.typeOfAction = "DEL"
            
            this.submitHandler()
          },

      });
    },

    cutItem(){
      this.cutLengthIsWrong = !(this.cutLength < this.stockItem.length && this.cutLength > 0)
      
      if (this.cutLength < this.stockItem.length && this.cutLength > 0){
        
        fetch(store.Api_url + "/cut-item/"+String(this.stockItem.id)+"/"+String(this.cutLength), Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
                notie.alert({
                      type: 'error',
                      text: "Akcia odrezanie z kusa sa nepodarila: " + responseData.data.message,
                      position: "top"
                    })           
            } else {
              
              this.stockItem = responseData.data
              this.cutLength = 0
              router.push("/mod-stock/stock-items/"+String(this.stockItem.id));

            }
          })
          .catch((error) => {
            notie.alert({
                      type: 'error',
                      text: "Akcia odrezanie z kusa sa nepodarila: " + error,
                      position: "top"
            })           
      });
      }
    },

    validateForm() {
      this.isSubmitted = true; 
  
    },

    filterProducts(categoryId:number){
      fetch(this.store.Api_url + "/v1/product?query=deleted:0,category_id:"+categoryId, Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
             
              notie.alert({
                type: 'error',
                text: "Zoznam produktov sa nepodarilo načítať"
              })
            } else {
              
              this.products = responseData.data

            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri načítaní produktov" + error);
      })
    },

    selectProduct(){
      this.stockItem.product = this.selectedProduct
      this.stockItem.length = this.selectedProduct.length
      this.stockItem.code = this.selectedProduct.code + "_"

      // zistím počet všetkých existujúcich kusov podľa prefixu
      fetch(this.store.Api_url + "/v1/stock-item?query=code__icontains:"+this.selectedProduct.code, Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
             
              notie.alert({
                type: 'error',
                text: "Nebolo možné automaticky vytvoriť kód kusa"
              })
            } else {
              
              this.stockItem.code = "Z_"+this.selectedProduct.code +"_"+String(responseData.totalRecords+1)
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri vytváraní kódu kusa" + error);
      })

    },

    selectOrder(order){
      
        this.stockItem.order = order
        
        this.visibleSelect = false
    },
    onOrderPage(event) {
        this.selectParams.first = event.first; 

        this.loadLazyDataOrders(this.selectParams)
    },
      
    onOrderFilter() {
        this.selectParams.filters.global = this.orderFilters.global.value
        this.selectParams.first = 0
        
        if(this.selectParams.filters.global.length > 2){
           this.loadLazyDataOrders(this.selectParams)
          }
    },

    initSelectFilters(){
        this.selectParams.first = 0
        this.selectParams.rows = 100
        this.selectParams.filters.global = ""
        this.orderfilters = {
            global: {value: null, matchMode: FilterMatchMode.CONTAINS},

        }
        this.isMovement = false
        this.action = ""
        this.typeOfAction = ""
    },

    printLabel(){
      Utils.printZplLabel(this.stockItem.id,"stock_item")
    },

    setColors(){

      const imitat = this.imitation ? "1" : "0"

      fetch(this.store.Api_url + "/v1/color?query=deleted:0,imitation:"+imitat, Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
            
              notie.alert({
                type: 'error',
                text: "Zoznam farieb sa nepodarilo načítať",
                position: "top"
              })
            } else {
              this.colors = responseData.data
            }
          })
          .catch((error) => {
            notie.alert({
                type: 'error',
                text: "Chyba pri načítaní farieb: "+error,
                position: "top"
              })
            //this.$emit('error', "Chyba pri načítaní farieb" + error);
      })
    },

    loadData(){

      this.setColors()

      fetch(store.Api_url + "/v1/category?query=deleted:0", Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
                notie.alert({
                      type: 'error',
                      text: "Zoznam kategórií sa nepodarilo načítať: " + responseData.data.message,
                      position: "top"
                    })           
            } else {
              
              this.categories = responseData.data

            }
          })
          .catch((error) => {
            notie.alert({
                      type: 'error',
                      text: "Zoznam kategórií sa nepodarilo načítať: " + error,
                      position: "top"
            })           
      });
      
      if (parseInt(String(this.routeParams.stockItemId), 10) > 0) {
        // editing an existing product
        const stockItemId = String(this.routeParams.stockItemId)

        fetch(store.Api_url + "/v1/stock-item/" + stockItemId, Security.requestOptions("GET"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                notie.alert({
                      type: 'error',
                      text: "Kus sa nepodarilo načítať: " + responseData.data.message,
                      position: "top"
                })         
              } else {
                
                this.stockItem = responseData.data
                this.selectedCategory = this.stockItem.product.category
                this.selectedColor = this.stockItem.color
                this.selectedProduct = this.stockItem.product
                this.oldLocation = this.stockItem.location
                this.oldOrderCode = this.stockItem.order.orderCode
                this.oldReadyToSpray = this.stockItem.readyToSpray
                this.oldSprayed = this.stockItem.sprayed
                //this.stockItem.order.customer = responseData.data.order.customer
                if (!this.stockItem.order){
                  this.stockItem.order = {id:0,orderCode:0,customer:{lastName:"",city:""}}
                }
                this.filterProducts(this.selectedCategory.id)
                Utils.updateStockMovement("stock_item_id",stockItemId)
              }
            })
            .catch((error) => {
              notie.alert({
                      type: 'error',
                      text: "Kus sa nepodarilo načítať: " + error,
                      position: "top"
                })         
              //this.$emit('error', "Chyba pri načítaní kusu" + error);
        })
      }else{
        store.stockMovements = []
      }
    },

    loadLazyDataOrders(params) {
        this.selectLoading = true;

        let queryParams = `&limit=${params.rows}&offset=${(params.first)}`;

        fetch(`${store.Api_url}${this.store.basicUrlFilterOrders}${queryParams}`, Security.requestOptions("POST",params.filters))
        .then((response) => response.json())
        .then((responseData) => {
          if (!responseData.error) {
            if (responseData.data){
              this.orderOptions = responseData.data
            }else{this.orderOptions = []}
            this.selectParams.totalRecords = responseData.totalRecords
            this.selectLoading = false;
          }
        })
        .catch((error) => {
          this.orderOptions = []
          this.selectLoading = false;
        })
      },


  },

  beforeRouteUpdate(to, from, next) {
        if (Security.requireToken()){
        this.routeParams = to.params
        store.selectModul = this.$route.path.split("/")[1]
        
        this.initSelectFilters()
        this.loadLazyDataOrders(this.selectParams)

        this.loadData()  

        next()
      }
  },

  beforeMount() {
    
    if (Security.requireToken()){
      
      this.routeParams = this.$route.params
      store.selectModul = this.$route.path.split("/")[1]
      
      this.initSelectFilters()
      this.loadLazyDataOrders(this.selectParams)
     
      this.loadData()


    }

  }
}
</script>



<style scoped>

</style>